<template>
  <div
    class="main-content-title"
    style="max-width: 1400px; width: 100%; margin: 0 auto"
  >
    <h2 style="font-size: 28px">
      {{ noticeType === 1 ? $t("title.notice") : $t("title.archives") }}
    </h2>
  </div>
  <div style="margin-top: 10px;">
    <BoardView />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useNoticesStore } from "@/store/notices";
import BoardView from "./board/BoardView.vue";

export default defineComponent({
  name: "NoticeView",
  components: { BoardView },

  setup() {
    const route = useRoute();

    const noticesStore = useNoticesStore();
    const { noticeType, noticeDetailType, noticeId } = storeToRefs(noticesStore);

    onMounted(async () => {
      if (noticeType.value === 0) {
        noticeType.value = route.path === "/NoticeView" ? 1 : 2;
        if (noticeType.value === 1) {
          noticeDetailType.value = localStorage.getItem("productType") || 1;
        } else {
          noticeDetailType.value = Number(route.query.type) || 1;
        }
        await noticesStore.fetchNotices();
      }

      noticeId.value = Number(route.query.id) || null;
    });
    
    return {
      noticeType,
    };
  },
});
</script>
